import { Loader2 } from 'lucide-react'

interface LoadingIndicatorProps {
  isParsing: boolean
  isValidating: boolean
}

export function LoadingIndicator({
  isParsing,
  isValidating,
}: LoadingIndicatorProps) {
  if (!isParsing && !isValidating) return null

  return (
    <div className='flex items-center justify-center gap-2 py-4'>
      <Loader2 className='h-5 w-5 animate-spin text-blue-500' />
      <span className='text-sm text-gray-600'>
        {isParsing ? 'Parsing file...' : 'Validating data...'}
      </span>
    </div>
  )
}

